import React, { useEffect, useState } from "react";
import { Table, Button, Space, Select, Input, Dropdown, Menu } from "antd";
import { get, del } from "../API/api_helper";
import Swal from "sweetalert2";
import StudentModal from "../Modals/StudentModal";
import StudentViewModal from "../Modals/StudentViewModal";
import { EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { EditOutlined, DeleteOutlined, PrinterOutlined, FilePdfOutlined, PlusOutlined, FilterOutlined, SearchOutlined } from "@ant-design/icons";
import SendIdModal from "../Modals/SendIdModal";
import GradeModal from "../Modals/GradeModal";
import { log } from "console";

const StudentTable = () => {
  const [students, setStudents] = useState([]);
  const [allStudents, setAllStudents] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState<any | null>(null);
  const [grades, setgrades] = useState<string[]>([]);
  const [selectedgrade, setSelectedgrade] = useState("");
  const [divisions] = useState(["A", "B", "C", "D", "E", "F"]);
  const [selectedDivision, setSelectedDivision] = useState("");
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [showSendIdModal, setShowSendIdModal] = useState(false);
  const [showGradeModal, setShowGradeModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [gradesList, setGradesList] = useState<{ id: string; grade: string }[]>([]);

  const fetchStudents = async (page = 1) => {
    setLoading(true);
    try {
      const url = `/students?page=${page}` +
        (selectedgrade ? `&grade=${selectedgrade}` : "") +
        (selectedDivision ? `&division=${selectedDivision}` : "") +
        (searchText ? `&search=${searchText}` : ""); // <-- added this line

      const res = await get(url);
      const dataArray = res.data || res;

      setStudents(dataArray);
      setAllStudents(dataArray);

      // console.log("Fetched students data:", dataArray);

      setPagination({
        current: res.current_page || 1,
        total: res.total || dataArray.length,
        pageSize: res.per_page || 10,
      });

      // if (!grades.length && Array.isArray(dataArray)) {
      //   const uniquegrades = Array.from(new Set(dataArray.map((s: any) => s.grade)));
      //   setgrades(uniquegrades);
      //   if (!selectedgrade && uniquegrades.length > 0) {
      //     setSelectedgrade(uniquegrades[0]);
      //   }
      // }
    } catch (error) {
      console.error("Failed to fetch students:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchGrades = async () => {
      try {
        const res = await get("/grades");
        setGradesList(res || []);

        if (res && res.length > 0 && !selectedgrade) {
          setSelectedgrade(res[0].id);
        }

      } catch (error) {
        console.error("Failed to fetch grades:", error);
      }
    };
    fetchGrades();
  }, []);

  const transformStudentForView = (student: any) => {
    const gradeObj = gradesList.find(
      (g) => String(g.id) === String(student.grade)
    );


    const divisionObj = divisionList.find(
      (d) => String(d.id) === String(student.division)
    );


    return {
      ...student,
      grade: gradeObj ? gradeObj.grade : student.grade,
      division: divisionObj ? divisionObj.name : "-",
    };
  };


  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchStudents(1);
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [selectedgrade, selectedDivision, searchText]);

  const handleDelete = async (id: number) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This record will be deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (confirm.isConfirmed) {
      await del(`/students/${id}`);
      Swal.fire("Deleted!", "Student has been deleted.", "success");
      fetchStudents();
    }
  };

  const handlePrint = async (id: number) => {
    try {
      const html = await get(`/idcard/print/${id}`, { responseType: "text" });
      const printWindow = window.open("", "_blank");
      if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(html);
        printWindow.document.close();
      }
    } catch (error) {
      console.error("Failed to fetch print data:", error);
    }
  };

  const handlePrintAll = async () => {

    try {

      const params = new URLSearchParams();
      if (selectedgrade) params.append("grade", selectedgrade);
      if (selectedDivision) params.append("division", selectedDivision);
      if (searchText) params.append("search", searchText);

      const html = await get(`/idcard/print-all?${params.toString()}`, { responseType: "text" });

      const printWindow = window.open("", "_blank");
      if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(html);
        printWindow.document.close();
      }

    } catch (error) {
      console.error("Failed to print all:", error);
    }
  };


  const handleDownloadPdf = async (id: number, name: string) => {
    try {
      const blob = await get(`/idcards/download/${id}`, { responseType: "blob" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `IDCard_${name}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download PDF:", error);
      Swal.fire("Error", "Failed to download PDF", "error");
    }
  };

  const handleSendPdf = async () => {


  }

   const handleDownloadAllPdf = async () => {
    try {
      const params = new URLSearchParams();
      if (selectedgrade) params.append("grade", selectedgrade);
      if (selectedDivision) params.append("division", selectedDivision);
      if (searchText) params.append("search", searchText);

      const blob = await get(`/idcard/download-all?${params.toString()}`, { responseType: "blob" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `All_Students_IDCards.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download PDF:", error);
      Swal.fire("Error", "Failed to download PDF", "error");
    }
  };



  useEffect(() => {
    fetchStudents();
  }, [selectedgrade, selectedDivision]);

  const divisionList = [
    { id: "1", name: "A" },
    { id: "2", name: "B" },
    { id: "3", name: "C" },
    { id: "4", name: "D" },
    { id: "5", name: "E" },
    { id: "6", name: "F" },
  ];


  const columns = [
    { title: "Admission No", dataIndex: "admission_no" },
    { title: "Name", dataIndex: "name" },
    {
      title: "Grade",
      dataIndex: "grade",
      key: "grade",
      render: (grade_id: string | number) => {
        const g = gradesList.find(item => String(item.id) === String(grade_id));
        return g ? g.grade : "-";
      }
    }
    ,
    {
      title: "Division",
      dataIndex: "division",
      key: "division",
      render: (division_id: string | number) => {
        const d = divisionList.find(item => String(item.id) === String(division_id));
        return d ? d.name : "-";
      }
    }
    ,
    { title: "Phone", dataIndex: "phone" },
    { title: "Blood Group", dataIndex: "blood_group" },
    { title: "Academic period", dataIndex: "academic_period" },
    {
      title: "Actions",
      render: (_: any, record: any) => {
        const menu = (
          <Menu
            onClick={({ key }) => {
              if (key === "edit") {
                setSelectedStudent(record);
                setShowModal(true);
              } else if (key === "delete") {
                handleDelete(record.id);
              } else if (key === "print") {
                handlePrint(record.id);
              } else if (key === "pdf") {
                handleDownloadPdf(record.id, record.name);
              }
            }}
            items={[
              { key: "edit", icon: <EditOutlined />, label: "Edit" },
              { key: "delete", icon: <DeleteOutlined />, label: "Delete" },
              { key: "print", icon: <PrinterOutlined />, label: "Print" },
              { key: "pdf", icon: <FilePdfOutlined />, label: "Download PDF" },
            ]}
          />

        );

        return (
          <Space>
            <Button
              type="link"
              icon={<EyeOutlined />}
              onClick={() => {
                const transformed = transformStudentForView(record);
                setSelectedStudent(transformed);
                setViewModalVisible(true);
              }}
            />

            <Dropdown overlay={menu} placement="bottomRight" trigger={['click']}>
              <Button icon={<MoreOutlined />} />
            </Dropdown>

          </Space>
        );
      },
    },
  ];

  return (
    <div className="p-4">
      <div style={{ marginBottom: "16px" }}>
        {/* Top Row: Title & Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "8px",
            flexWrap: "wrap",
            gap: "8px",
          }}
        >
          <h5 style={{ fontSize: "25px" }}>Student List</h5>
          <Space size="middle" wrap>
            <Button type="default" icon={<PrinterOutlined />} onClick={handlePrintAll}>
              Print All
            </Button>
            <Button type="default" icon={<FilePdfOutlined />} onClick={handleDownloadAllPdf}>
              Download All
            </Button>
            <Button
              type="default"
              icon={<FilePdfOutlined />}
              onClick={() => setShowSendIdModal(true)}
            >
              Send ID
            </Button>

            {/* <Button type="default" icon={<PlusOutlined />} onClick={() => setShowGradeModal(true)}>
              Add Grade
            </Button> */}
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                setSelectedStudent(null);
                setShowModal(true);
              }}
            >
              Add Student
            </Button>
          </Space>
        </div>


        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "8px",
            flexWrap: "wrap",
          }}
        >

          <Input
            placeholder="Search by Name or Admission No"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            prefix={<SearchOutlined />}
            style={{ minWidth: 150, maxWidth: 200 }}
            allowClear
          />

          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            <Select
              placeholder="Filter by Grade"
              style={{ minWidth: 140 }}
              value={selectedgrade || undefined}
              suffixIcon={<FilterOutlined />}
              onChange={(value) => setSelectedgrade(value || "")}
            >
              {gradesList.map((grade) => (
                <Select.Option key={grade.id} value={grade.id}>
                  {grade.grade}
                </Select.Option>
              ))}

            </Select>

            <Select
              placeholder="Filter by Division"
              style={{ minWidth: 120 }}
              allowClear
              value={selectedDivision || undefined}
              onChange={(value) => setSelectedDivision(value || "")}
            >
              {divisionList.map((div) => (
                <Select.Option key={div.id} value={div.id}>
                  {div.name}
                </Select.Option>
              ))}
            </Select>

          </div>
        </div>
      </div>


      <Table
        dataSource={students}
        columns={columns}
        rowKey="id"
        loading={loading}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          onChange: (page: number) => fetchStudents(page),
        }}
      />

      {showModal && (
        <StudentModal
          show={showModal}
          onHide={() => setShowModal(false)}
          student={selectedStudent}
          refresh={() => fetchStudents(pagination.current)}
        />
      )}

      <StudentViewModal
        visible={viewModalVisible}
        onClose={() => setViewModalVisible(false)}
        student={selectedStudent}
      />

      <SendIdModal
        show={showSendIdModal}
        handleClose={() => setShowSendIdModal(false)}
        grade={selectedgrade}
        division={selectedDivision}
      />



      {/* {showGradeModal && (
        <GradeModal show={showGradeModal} onHide={() => setShowGradeModal(false)} />
      )} */}

    </div>
  );
};

export default StudentTable;
